// extracted by mini-css-extract-plugin
export default {"mapDiv":"mapDiv-fqe2o","mobileMap":"mobileMap-HmXg4"};